/* eslint-disable no-unused-vars */
/* eslint-disable no-await-in-loop */
/* eslint-disable react/no-this-in-sfc */
/* eslint-disable no-continue */
/* eslint-disable no-restricted-syntax */
import React, { useEffect, useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import { BackOfficeAPI, PoliciesAPI } from '@services/api';
import { redirectToApp, PROCESS_STATUS } from '@plataforma/utils';
import { ENDORSEMENT_STATUS } from '_/utils/constants';
import { getUserProfile } from '@services/auth';
import { forceDownload } from '../../../utils/fileHelper';
import EndorsementsWrapper from '../components/EndorsementsWrapper';

function EndorsementDetail({
  endorsements,
  documentNumber: processNumber,
  policyStatus
}) {
  const [endorsementsDetailsList, setEndorsements] = useState(endorsements);
  const [userProfile, setUserProfile] = useState('');

  const dispatch = useDispatch();

  async function getOpenedQuestion(documentNumber) {
    try {
      const response = await BackOfficeAPI.hasOpenedQuestion(documentNumber);
      const { hasQuestioning } = response.data;
      return hasQuestioning;
    } catch (e) {
      return false;
    }
  }

  const getOpenedQuestionEndorsement = useCallback(async endorsementsList => {
    for (const endorsement of endorsementsList) {
      const isInternalized =
        endorsement.status === ENDORSEMENT_STATUS.internalized;
      if (!isInternalized) {
        const { documentNumber } = endorsement;
        const hasOpenedQuestion = await getOpenedQuestion(documentNumber);
        endorsement.hasOpenedQuestion = hasOpenedQuestion;
        endorsement.hasOpenedQuestionDescription = hasOpenedQuestion
          ? 'hasOpenedQuestion'
          : 'default';
      }
    }
    return endorsementsList;
  }, []);

  const treatEndorsements = useCallback(
    async endorsementsList => {
      const filtered = endorsementsList.filter(
        endorsementItem =>
          endorsementItem.status !== ENDORSEMENT_STATUS.undefined &&
          endorsementItem.status !== ENDORSEMENT_STATUS.canceled
      );

      const treatedEndorsements = await getOpenedQuestionEndorsement(filtered);
      return treatedEndorsements;
    },
    [getOpenedQuestionEndorsement]
  );

  const endorsementsDetails = useCallback(async () => {
    const completeEndorsements = await treatEndorsements(endorsements);

    setEndorsements(completeEndorsements);
  }, [endorsements, treatEndorsements]);

  const handleAnswerQuestion = async documentNumber => {
    redirectToApp('questionamento', '', {
      documentNumber
    });
  };

  const handleRequestEmission = async documentNumber => {
    redirectToApp('endosso', 'retake', {
      document: documentNumber
    });
  };

  const handleNewEndorsement = async () => {
    redirectToApp('endosso', 'new', {
      documentNumber: processNumber,
      hasEndorsement: !!endorsements.length
    });
  };

  const handleClickDownloadPolicy = async documentNumber => {
    const {
      data: { linkDocumento = '', linkMinuta = '' }
    } = await PoliciesAPI.GetPolicyInformation(documentNumber);

    const link = linkDocumento || linkMinuta;
    return forceDownload(link);
  };

  useEffect(() => {
    if (endorsements) {
      endorsementsDetails();
    }
  }, [dispatch, endorsements, endorsementsDetails]);

  useEffect(() => {
    const userProfileLocal = getUserProfile();
    setUserProfile(userProfileLocal && userProfileLocal.toLowerCase());
  }, []);

  return (
    userProfile &&
    userProfile !== 'tomador' && (
      <EndorsementsWrapper
        processNumber={processNumber}
        endorsements={endorsementsDetailsList}
        onClickAnswerQuestion={handleAnswerQuestion}
        onClickRequestEmission={handleRequestEmission}
        onClickNewEndorsement={handleNewEndorsement}
        onClickDownloadPolicy={handleClickDownloadPolicy}
        policyStatus={policyStatus}
      />
    )
  );
}

EndorsementDetail.propTypes = {
  endorsements: PropTypes.arrayOf(PropTypes.object),
  documentNumber: PropTypes.string,
  policyStatus: PropTypes.object
};

export default EndorsementDetail;
